import { render, staticRenderFns } from "./FundingProjectsMonitors.vue?vue&type=template&id=7a56ba76&"
import script from "./FundingProjectsMonitors.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsMonitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports